import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import {registrarOficio, GetEmisor, GetUltimoID,POSTCartilla, POSTPreregistro} from '../../services/SecurityService';
import { DropdownList } from 'react-widgets';
import axios from "axios";
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom'
import {Modal,Button} from 'react-bootstrap'
import {isEmpty, isMail} from '../../config/helpers/Validations';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import EmisorIcon from '@material-ui/icons/AccountBoxRounded';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';


export default class RegistroOficio extends Component {
  constructor(props) {
    super(props);
  
  
    this.validateForm = this.validateForm.bind(this);
  

    this.onChangeNoFolio = this.onChangeNoFolio.bind(this);
this.onChangeNoOficio = this.onChangeNoOficio.bind(this);
this.onChangeFechaDocumento = this.onChangeFechaDocumento.bind(this);
this.onChangeFechaExpiracion = this.onChangeFechaExpiracion.bind(this);
//this.onChangeCategoria = this.onChangeCategoria.bind(this);
this.onChangePersona = this.onChangePersona.bind(this);
this.onChangenombre = this.onChangenombre.bind(this);
this.onChangetelefono = this.onChangetelefono.bind(this);
this.onChangedomicilio = this.onChangedomicilio.bind(this);
this.onChangerfc = this.onChangerfc.bind(this);
this.onChangecorreo = this.onChangecorreo.bind(this);
this.onChangeapoderado = this.onChangeapoderado.bind(this);
this.onChangecalle = this.onChangecalle.bind(this);
this.onChangeno = this.onChangeno.bind(this);
this.onChangecolonia = this.onChangecolonia.bind(this);
this.onChangecodigoPostal = this.onChangecodigoPostal.bind(this);
this.onChangelocalidad = this.onChangelocalidad.bind(this);
this.onChangeentreCalle = this.onChangeentreCalle.bind(this);
this.onChangeyCalle = this.onChangeyCalle.bind(this);
this.onChangeinversion = this.onChangeinversion.bind(this);
this.onChangeobservaciones = this.onChangeobservaciones.bind(this);
this.onChangedenominacionComercial = this.onChangedenominacionComercial.bind(this);
this.onChangetipoEstablecimiento = this.onChangetipoEstablecimiento.bind(this);

this.onChangemedidas = this.onChangemedidas.bind(this);
this.onChangeAforo = this.onChangeAforo.bind(this);
this.onChangerazonsocial = this.onChangerazonsocial.bind(this);
this.onChangeclavecatastral = this.onChangeclavecatastral.bind(this);

//this.onChangenombreNegocio = this.onChangenombreNegocio.bind(this);
//this.onChangetelefonoNegocio = this.onChangetelefonoNegocio.bind(this);



this.onChangeEmisor = this.onChangeEmisor.bind(this);
this.onChangeAsuntos = this.onChangeAsuntos.bind(this);
this.onChangeObservaciones = this.onChangeObservaciones.bind(this);
this.onChangePruebaEsta = this.onChangePruebaEsta.bind(this);

this.onChangeCMatricula = this.onChangeCMatricula.bind(this);
this.onChangeCApellidoPaterno = this.onChangeCApellidoPaterno.bind(this);
this.onChangeCApellidoMaterno = this.onChangeCApellidoMaterno.bind(this);
this.onChangeCNombre = this.onChangeCNombre.bind(this);
this.onChangeCFechaNacimiento = this.onChangeCFechaNacimiento.bind(this);
this.onChangeCClase = this.onChangeCClase.bind(this);
this.onChangeCLugarNacimiento = this.onChangeCLugarNacimiento.bind(this);

this.onChangeCNombrePadre = this.onChangeCNombrePadre.bind(this);

this.onChangeCNombreMadre = this.onChangeCNombreMadre.bind(this);
this.onChangeCTutor = this.onChangeCTutor.bind(this);
this.onChangeCEstadoCivil = this.onChangeCEstadoCivil.bind(this);
this.onChangeCOcupacion = this.onChangeCOcupacion.bind(this);
this.onChangeCLeerEscribir = this.onChangeCLeerEscribir.bind(this);
this.onChangeCCurp = this.onChangeCCurp.bind(this);
this.onChangeCNivelEstudios = this.onChangeCNivelEstudios.bind(this);
this.onChangeCGradoMaximo = this.onChangeCGradoMaximo.bind(this);
this.onChangeCDomicilio = this.onChangeCDomicilio.bind(this);
this.onChangeCFechaEntrega = this.onChangeCFechaEntrega.bind(this);
this.onChangeCFechaRegistro = this.onChangeCFechaRegistro.bind(this);

this.onSubmit = this.onSubmit.bind(this);
this.handleShow = this.handleShow.bind(this);
this.handleClose = this.handleClose.bind(this);
this.onChangeHandler = this.onChangeHandler.bind(this);


this.state = {
selectedFile: [],
      RD : "",
      NoFolio: '',
      NoOficio: '',
      obj : "",
      Categoria:'',
      Asuntos:'',
      Observaciones:'',
      FechaDocumento:'',
      FechaExpiracion:'',
      nombre:'',
      domicilio:'',
      telefono:'',
      medidas:'',
      Aforo:'',
      razonsocial:'',
      clavecatastral:'',
      //nombreNegocio:'',
      //telefonoNegocio:'',

      CMatricula:'',
      CApellidoPaterno:'',
      CApellidoMaterno:'',
      CNombre:'',
      CFechaNacimiento:'',
      CClase:'',
      CLugarNacimiento:'',
      CNombrePadre:'',
      CNombreMadre:'',
      CTutor:'',
      CEstadoCivil:'',
      COcupacion:'',
      CLeerEscribir:'SI',
      CCurp:'',
      CNivelEstudios:'',
      CGradoMaximo:'',
      CDomicilio:'',
      CFechaEntrega:'',
      CFechaRegistro:'',

      errNoFolio: '',
      errNoOficio: '',
      Categorias :[{descripcion : "SOLTERO", id :0},
      {descripcion : "CASADO", id :7},
      {descripcion : "DIVORCIADO", id :8},
      {descripcion : "VIUDO", id :9},
      
    ],
    show: false,
    Emisor : [],
    Persona :[{descripcion : "FISICA", id :"F"},
      {descripcion : "MORAL", id :"M"}
    ],
    redirect: "",
    Personas : "",
    value: "",
    value2 : "",
    value3 : "",

    giros : "",
    inversion:  "",
      rfc: "",
      calle: "",
      no: "",
      colonia: "",
      codigoPostal: "",
      localidad: "",
      entreCalle: "",
      yCalle: "",
      denominacionComercial: "",
      tipoEstablecimiento: "",
      apoderado : "",
      correo: "",

      nivelE :['SIN ESTUDIOS',
      'PREESCOLAR',
      'PRIMARIA',
      'SECUNDARIA',
      'BACHILLERATO',
      'LICENCIATURA','INGENIERÍA','TEC SUP UNIVER',
      'POSGRADO'
    ],
    oE:[
      'ESTUDIANTE','EMPLEADO'
    ]
       

      
    }
    
  }

  componentDidMount(){
    console.log("el  usuario")
    console.log(this.state.userD)
   

  
}

validateForm(){
  let valid=true, errNoFolio="", errNoOficio="";
  if(isEmpty(this.state.NoFolio)){
    errNoFolio = "Campo de Folio, esta vacío";
    valid=false;
  }

  if(isEmpty(this.state.NoOficio)){
    errNoOficio = "Campo de Oficio, esta vacío";
    valid=false;
  }
  if(!valid){
    this.setState({errNoFolio: errNoFolio, errNoOficio: errNoOficio});
  }
  return valid;
}

onChangeNoFolio(e) {
  this.setState({
  NoFolio: e.target.value.toUpperCase()
  });
  }
  onChangenombre(e) {
  this.setState({
  nombre: e.target.value.toUpperCase()
  });
  }
  onChangedomicilio(e) {
  this.setState({
  domicilio: e.target.value.toUpperCase()
  });
  }
  onChangetelefono(e) {
  this.setState({
  telefono: e.target.value.toUpperCase()
  });
  }
  onChangeNoOficio(e) {
  this.setState({
  NoOficio: e.target.value.toUpperCase()
  }) 
  }
  onChangerfc(e) {
  this.setState({
  rfc: e.target.value.toUpperCase()
  }) 
  }
  onChangecorreo(e) {
  this.setState({
  correo: e.target.value.toUpperCase()
  }) 
  }
  onChangeapoderado(e) {
  this.setState({
  apoderado: e.target.value.toUpperCase()
  }) 
  }
  onChangecalle(e) {
  this.setState({
  calle: e.target.value.toUpperCase()
  }) 
  }
  onChangeno(e) {
  this.setState({
  no: e.target.value.toUpperCase()
  }) 
  }
  onChangecolonia(e) {
  this.setState({
  colonia: e.target.value.toUpperCase()
  }) 
  }
  onChangecodigoPostal(e) {
  this.setState({
  codigoPostal: e.target.value.toUpperCase()
  }) 
  }
  onChangelocalidad(e) {
  this.setState({
  localidad: e.target.value.toUpperCase()
  }) 
  }
  onChangeentreCalle(e) {
  this.setState({
  entreCalle: e.target.value.toUpperCase()
  }) 
  }
  onChangeyCalle(e) {
  this.setState({
  yCalle: e.target.value.toUpperCase()
  }) 
  }
  onChangeinversion(e) {
  this.setState({
  inversion: e.target.value.toUpperCase()
  }) 
  }
  onChangeobservaciones(e) {
  this.setState({
  observaciones: e.target.value.toUpperCase()
  }) 
  }
  onChangemedidas(e) {
    this.setState({
    medidas: e.target.value.toUpperCase()
    });
    }
    onChangeAforo(e) {
      this.setState({
      Aforo: e.target.value.toUpperCase()
      });
      }
      onChangerazonsocial(e) {
        this.setState({
        razonsocial: e.target.value.toUpperCase()
        });
        }
        onChangeclavecatastral(e) {
          this.setState({
          clavecatastral: e.target.value.toUpperCase()
          });
          }
          onChangeCMatricula(e) {
            this.setState({
            CMatricula: e.target.value.toUpperCase()
            });
            }
            onChangeCApellidoPaterno(e) {
              this.setState({
                CApellidoPaterno: e.target.value.toUpperCase()
              });
              }
              onChangeCApellidoMaterno(e) {
                this.setState({
                  CApellidoMaterno: e.target.value.toUpperCase()
                });
                }
                onChangeCNombre(e) {
                  this.setState({
                    CNombre: e.target.value.toUpperCase()
                  });
                  }
                  onChangeCFechaNacimiento(e) {
                    this.setState({
                      CFechaNacimiento: e.target.value.toUpperCase()
                    });
                    }
                    onChangeCClase(e) {
                      const value = e.target.value.toUpperCase();
                    
                      // Limitar a 4 caracteres
                      if (value.length <= 4) {
                        this.setState({
                          CClase: value,
                        });
                      }
                    }
                  onChangeCLugarNacimiento(e) {
                    this.setState({
                      CLugarNacimiento: e.target.value.toUpperCase()
                    });
                    }
                    onChangeCNombrePadre(e) {
                      this.setState({
                        CNombrePadre: e.target.value.toUpperCase()
                      });
                      }
                      onChangeCNombreMadre(e) {
                        this.setState({
                          CNombreMadre: e.target.value.toUpperCase()
                        });
                        }
                        onChangeCTutor(e) {
                          this.setState({
                            CTutor: e.target.value.toUpperCase()
                          });
                          }
                          onChangeCOcupacion(e) {
                            this.setState({
                              COcupacion: e.target.value.toUpperCase()
                            });
                          }
                          onChangeCLeerEscribir(e) {
                            this.setState({
                              CLeerEscribir: e.target.value.toUpperCase()
                            });
                          }
                          onChangeCCurp(e) {
                            const inputValue = e.target.value.toUpperCase();
                            const maxLength = 18;
                            const trimmedValue = inputValue.slice(0, maxLength); // Recorta el valor a 18 caracteres como máximo
                            this.setState({ CCurp: trimmedValue });
                          }
                          
                          onChangeCNivelEstudios(e) {
                            this.setState({
                              CNivelEstudios: e.target.value.toUpperCase()
                            });
                          }
                          onChangeCGradoMaximo(e) {
                            this.setState({
                              CGradoMaximo: e.target.value.toUpperCase()
                            });
                          }
                          onChangeCDomicilio(e) {
                            this.setState({
                              CDomicilio: e.target.value.toUpperCase()
                            });
                          }
                          onChangeCFechaEntrega(e) {
                            this.setState({
                              CFechaEntrega: e.target.value.toUpperCase()
                            });
                           }
                            onChangeCFechaRegistro(e) {
                              this.setState({
                                CFechaRegistro: e.target.value.toUpperCase()
                              });
                            }

      
      

  /*
onChangenombreNegocio(e) {
        this.setState({
        nombreNegocio: e.target.value.toUpperCase()
        });
        }
        onChangetelefonoNegocio(e) {
          this.setState({
          telefonoNegocio: e.target.value.toUpperCase()
          });
          }
  */
  onChangedenominacionComercial(e) {
  this.setState({
  denominacionComercial: e.target.value.toUpperCase()
  }) 
  }
  onChangetipoEstablecimiento(e) {
  this.setState({
  tipoEstablecimiento: e.target.value.toUpperCase()
  }) 
  }
  onChangeEmisor(descripcion) {
  console.log(descripcion);
  let { Emisor} = this.state;
  
  let newOption = descripcion;
  
  this.setState({
  value2: newOption, 
  Emisor: [...Emisor],
  otro2: Emisor.filter(tipo => tipo.toLowerCase().includes(descripcion.toLowerCase()))
  })
  }
  onChangeCEstadoCivil(descripcion) {
  console.log(descripcion);
  let { Categorias} = this.state;
  
  let newOption = descripcion;
  
  this.setState({
  value: newOption, 
  Categorias: [...Categorias],
  otro: Categorias.filter(tipo => tipo.descripcion.toLowerCase().includes(descripcion.descripcion.toLowerCase()))
  })
  }
  
  onChangePersona(descripcion) {
  console.log(descripcion);
  let { Persona} = this.state;
  
  let newOption = descripcion;
  
  this.setState({
  value3: newOption, 
  Persona: [...Persona],
  otro: Persona.filter(tipo => tipo.descripcion.toLowerCase().includes(descripcion.descripcion.toLowerCase()))
  })
  }
  
  onChangeAsuntos(e) {
  this.setState({
  Asuntos: e.target.value.toUpperCase()
  })
  }
  onChangeObservaciones(e) {
  this.setState({
  Observaciones: e.target.value.toUpperCase()
  })
  }
  onChangeFechaDocumento(e) {
  this.setState({
  FechaDocumento: e.target.value.toUpperCase()
  })
  }
  onChangeFechaExpiracion(e) {
  this.setState({
  FechaExpiracion: e.target.value.toUpperCase()
  })
  }
  
  onChangePruebaEsta(e) {
  this.setState({
  selectedFile: e.target.value.toUpperCase()
  })
  }
  
  onChangeHandler(e){
  
  this.setState({
  selectedFile: e.target.files[0]
  })
  }
  
  onClickHandler() {
  const data = new FormData()
  data.append('fileStg', this.state.selectedFile)
  console.log("Esta daga<<")
  console.log(this.state.selectedFile)
  console.log(this.state.selectedFile.name)
  
  // axios.post("http://cartillas-apis.herokuapp.com/postfile", data)
  // .then(response => alert(response.data))
  // .catch(err => alert(err.toString()));
  }
  
  handleClose() {
  this.setState({ show: false });
  }
  
  handleShow() {
  this.setState({ show: true });
  }
  
  fechaNombre(fecha){
    let fN=fecha.substring(0,10);
    let fnn="";
    
    let af=fN.split("-");
    
    fnn=af[2]+" DE ";
    
    if(af[1]=="01"){
      fnn=fnn+"ENERO DE "
    }else if(af[1]=="02"){
      fnn=fnn+"FEBRERO DE "
    }
    else if(af[1]=="03"){
      fnn=fnn+"MARZO DE "
    }
    else if(af[1]=="04"){
      fnn=fnn+"ABRIL DE "
    }
    else if(af[1]=="05"){
      fnn=fnn+"MAYO DE "
    }
    else if(af[1]=="06"){
      fnn=fnn+"JUNIO DE "
    }
    else if(af[1]=="07"){
      fnn=fnn+"JULIO DE "
    }
    else if(af[1]=="08"){
      fnn=fnn+"AGOSTO DE "
    }
    else if(af[1]=="09"){
      fnn=fnn+"SEPTIEMBRE DE "
    }
    else if(af[1]=="10"){
      fnn=fnn+"OCTUBRE DE "
    }
    else if(af[1]=="11"){
      fnn=fnn+"NOVIEMBRE DE "
    }
    else if(af[1]=="12"){
      fnn=fnn+"DICIEMBRE DE "
    }
    
    fnn=fnn+af[0];
    return fnn;
    }

  onSubmit(e) {
    e.preventDefault();
 //   this.onClickHandler();

 let nfn =this.fechaNombre(this.state.CFechaNacimiento);
 let nfe =this.fechaNombre(this.state.CFechaEntrega);

    const obj = {
     
     
      matricula: this.state.CMatricula,
      ap_paterno: this.state.CApellidoPaterno,
      ap_materno: this.state.CApellidoMaterno,
      nombre: this.state.CNombre,
      fecha_nac: this.state.CFechaNacimiento,
      clase: this.state.CClase,
      lugar_nac: this.state.CLugarNacimiento,
      nombre_padre: this.state.CNombrePadre,
      nombre_madre: this.state.CNombreMadre,
      tutor: this.state.CTutor,
      estado_civil: this.state.value.descripcion,
      ocupacion: this.state.COcupacion,
      leer_escribir: this.state.CLeerEscribir,
      CURP: this.state.CCurp,
      nivel_estudios: this.state.CNivelEstudios,
      grado: this.state.CGradoMaximo,
      domicilio: this.state.CDomicilio,
      fecha_entrega: this.state.CFechaEntrega,
      nfecha_entrega: nfe,
      nfecha_nac: nfn,
      //Derecha v Locales, izquierda Base de datos

    };
    console.log("cartilla obj");
    console.log(obj);
   
    
    POSTPreregistro(obj).then(response => {
     
      console.log("Aqui ese supone q se registro")
      console.log(response);
     // window.location.reload();
     if(response!="error en el servidor."){
     alert("Registro Guardado!");
     window.location.reload();}
    }).catch(err => console.log(err)); 
    
   
  }

  renderRedirect = () => {
    if (this.state.redirect=="F") {
      return <Redirect to={'/oficios/RegistroDocumentos1/' + this.state.obj}/>
    }
    else if(this.state.redirect=="M"){
      return <Link to='/oficios/RegistroDocumentos2'/>
    }
  }

 
  render() {


    let { value, Categorias, value2, Emisor, value3, Persona, Giro} = this.state;

    
    return (
        <div style={{ marginTop: 10 }}>
            
            <form onSubmit={this.onSubmit}>
              
           
                <div className="form-group" style={{padding:'65px'}}>
                <h4 align="center" > <EmisorIcon extendedIcon /> &nbsp;DATOS DE LA PERSONA   </h4> 
                  <hr></hr>
                <Grid container spacing={2} >
                <Grid item xs={4}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>NOMBRE(S) </label>
                    <input 
                     style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                    required
                      className="form-control"
                      value={this.state.CNombre}
                      onChange={this.onChangeCNombre}
                      />
                </div>
                </Grid>
                    
                      <Grid item xs={4}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>APELLIDO PATERNO </label>
                    <input 
                     style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                    required
                      className="form-control"
                      value={this.state.CApellidoPaterno}
                      onChange={this.onChangeCApellidoPaterno}
                      />
                </div>
                </Grid>
                <Grid item xs={4}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>APELLIDO MATERNO </label>
                    <input 
                     style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                    required
                      className="form-control"
                      value={this.state.onChangeCApellidoMaterno}
                      onChange={this.onChangeCApellidoMaterno}
                      />
                </div>
                </Grid>
                
                 </Grid>
                 <Grid container spacing={2} >
                    <Grid item xs={4}>
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>FECHA DE NACIMIENTO </label>
                    <input 
                     style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="date" 
                    max={`${new Date().getFullYear()}-12-31`}
                    required
                      className="form-control"
                      value={this.state.CFechaNacimiento}
                      onChange={this.onChangeCFechaNacimiento}
                      />
                      </Grid>

                   
                <Grid item xs={4}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>LUGAR DE NACIMIENTO </label>
                    <input 
                     style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                      required
                      className="form-control"
                      value={this.state.CLugarNacimiento}
                      onChange={this.onChangeCLugarNacimiento}
                      />
                </div>
                </Grid>
                <Grid item xs={6}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>NOMBRE DEL PADRE </label>
                    <input 
                     style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                    required
                      className="form-control"
                      value={this.state.CNombrePadre}
                      onChange={this.onChangeCNombrePadre}
                      />
                </div>
                </Grid>
                <Grid item xs={6}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>NOMBRE DE LA MADRE </label>
                    <input 
                     style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                    required
                      className="form-control"
                      value={this.state.CNombreMadre}
                      onChange={this.onChangeCNombreMadre}
                      />
                </div>
                </Grid>
                <Grid item xs={6}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>TUTOR SI LO TIENE </label>
                    <input 
                     style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                    
                      className="form-control"
                      value={this.state.CTutor}
                      onChange={this.onChangeCTutor}
                      />
                </div>
                </Grid>
                     
                    <Grid item xs={3}>
                     <label style={{color:'#5B6B79',fontSize:'14px'}}>ESTADO CIVIL </label>
                    <DropdownList 
                    required
                    filter
                            data={Categorias}
                            value={value}
                            allowCreate="onFilter"
                            style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px',width: '100%'}}
                            onChange={descripcion => this.onChangeCEstadoCivil(descripcion)}
                            textField="descripcion"
                            placeholder="ESTADO CIVIL..."
                          />                 
                    </Grid>
                    <Grid item xs={3}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>OCUPACIÓN </label>
                    <DropdownList
     value={this.state.COcupacion}      
    onChange={(nextValue) => this.setState({COcupacion:nextValue})}
      data={this.state.oE}
    />   
                </div>
                </Grid>
                <Grid item xs={2}>
            <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>SABE LEER Y ESCRIBIR </label>
                    <RadioGroup aria-label="emp_recolectora" name="emp_recolectora" value={this.state.CLeerEscribir} onChange={this.onChangeCLeerEscribir}>
          <FormControlLabel value="SI" control={<Radio />} label="SI" />
          <FormControlLabel value="NO" control={<Radio />} label="NO" />
          
      
        </RadioGroup>
                </div>
                </Grid>
                <Grid item xs={4}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>CURP </label>
                    <input 
                      style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                    required
                      className="form-control"
                      value={this.state.CCurp}
                      onChange={this.onChangeCCurp}
                      />
                </div>
                </Grid>
                <Grid item xs={4}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>NIVEL MÁXIMO DE ESTUDIOS </label>
              
<DropdownList
      value={this.state.CNivelEstudios}
      onChange={(nextValue) => this.setState({CNivelEstudios:nextValue})}
      data={this.state.nivelE}
    />
                </div>
                </Grid>
                <Grid item xs={2}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>GRADO MÁXIMO </label>
                    <input 
                      style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                   
                      className="form-control"
                      value={this.state.CGradoMaximo}
                      onChange={this.onChangeCGradoMaximo}
                      />
                </div>
                </Grid>

                <Grid item xs={10}>
                <div className="form-group">
                    <label style={{color:'#5B6B79',fontSize:'14px'}}>DOMICILIO </label>
                    <input 
                      style={{fontSize:'14px',padding:'14px',height:'48.13px',borderRadius:'10px'}}
                    type="text" 
                    required
                      className="form-control"
                      value={this.state.CDomicilio}
                      onChange={this.onChangeCDomicilio}
                      />
                </div>
                </Grid>
                
                    </Grid>
                    <hr></hr>
                    <div className="form-group">
                  
                  <input style={{float:'right',borderRadius:'40px'}} type="submit" value="REGISTRAR" className="btn btn-success"/>
              </div>
                </div>
                {}
                <Grid container spacing={2} >
                
               
                      </Grid>
                      
                
               
               
                {/*
                <label>Copia comprobante de domicilio de negocio: </label>
                      <input type="file" name="file" onChange={this.onChangeHandler} />
                 
               
                <a rel="noopener noreferrer" href={"http://intranet.tepic.gob.mx/archivoscartillas/"+this.state.Observaciones} target="_blank">Link Here</a>
                */}
               
                
               
                       
                <>
            
      
                <Modal 
               size="lg"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
              show={this.state.show} onHide={this.handleClose} centered>
                <Modal.Header closeButton>
                <Modal.Title>Documentos Persona : {this.state.Personas }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
               
               
                <this.state.RD obj={this.state.obj}/>
               
              
                </Modal.Body>
                
              </Modal>
            </>
               

                
               
            </form>
        </div>
    )
  }
}